import { render, staticRenderFns } from "./UploadContentFilesTab.vue?vue&type=template&id=401b76fa&scoped=true"
import script from "./UploadContentFilesTab.vue?vue&type=script&lang=js"
export * from "./UploadContentFilesTab.vue?vue&type=script&lang=js"
import style0 from "./UploadContentFilesTab.vue?vue&type=style&index=0&id=401b76fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401b76fa",
  null
  
)

export default component.exports